import React from "react";
import {
    Button,
    Dimensions,
    StyleSheet,
    Text,
    View
} from "react-native";

import {
  getFocusContact, setFocusContact, setNotifyContact, getOneContact
} from "../../API/API";
import {
    BriefingTab, NetworkTab, EntityTab, ThemeTab
} from "./SharedProfileTab"
import RichText from "../Shared/RichText";



const getDimensions = () => Dimensions.get('window');

class ContactProfile {
  load(id){
    return getOneContact(id).then(item => {
      return getFocusContact().then(data => {
	const focus = data[id] || {focus_enabled: false, notification_enabled: false};
	return {
	  item,
	  focus_enabled: focus.focus_enabled,
	  notification_enabled: focus.notification_enabled
	}
      });
    })
  }
  setFocus(item, focus_enabled) {
    const action = focus_enabled ? 'unset' : 'set'
    return setFocusContact(item.id, action).then(() => !focus_enabled)
  }
  setNotification(item, notification_enabled) {
    const action = notification_enabled ? 'unset' : 'set'
    return setNotifyContact(item.id, action).then(() => !notification_enabled)
  }
  getInfo(item) {
    return {
      title: item.firstname + " " + item.lastname,
      subtitle: "",
      description: item.biography,
      affiliations: item.affiliations,
    }
  }
  getTitle(item) {
    return item.firstname + " " + item.lastname;
  }
  getTab(props) {
    return [{
	title : 'Briefing',
	content: this._getBriefing(props),
      }, {
	title : 'Biographie',
	content : this._getBiography(props),
      }, {
	title : 'Réseaux',
	content : this._getReseau(props),
      }, {
	title : 'Entités',
	content : this._getEntity(props),
      }, {
	title : 'Themes',
	content : this._getTheme(props),
      },
    ]
  }
  _getBriefing(props) {
    const {navigation, route, item, type} = props;
    return <BriefingTab navigation={navigation} route={route} item={item} type={type} />
  }
  _getReseau(props) {
    const { item, type, navigation } = props;
    return <NetworkTab navigation={navigation} item={item} type={type} />
  }
  _getEntity(props) {
    const {navigation, item, type} = props;
    return <EntityTab navigation={navigation} item={item} type={type} />
  }
  _getTheme(props) {
    const {navigation, t, item, all_themes} = props;
    return <ThemeTab navigation={navigation} t={t} item={item} all_themes={all_themes} />
  }
  _getBiography(props) {
      const { width } = getDimensions();
      const { t, theme, item } = props;

      const styles = StyleSheet.create({
	container: {
	  backgroundColor: theme.colors.primary.White.value,
	  width: width-20,
	  padding: 20,
	  margin: 10,
	  borderRadius: 10
	},
	title: {
	  fontFamily: theme.fonts.title,
	  fontWeight: "600",
	  color: theme.colors.tertiary.black1.value,
	  fontSize: 17
	},
	text: {
	  fontFamily: theme.fonts.text,
	  color: theme.colors.tertiary.black1.value,
	  fontSize: 15
	}
      });
      return <View style={styles.container}>
	<Text style={styles.title}>{t('Biographie')}</Text>
	<Text style={styles.text}><RichText text={item.biography} /></Text>
	<Text style={styles.title}>{t('Career')}</Text>
	<Text style={styles.text}><RichText text={item.career} /></Text>
      </View>
  }
}

export default ContactProfile;
